export default {"src":"/_next/static/media/dex.081d7402.svg","height":84,"width":84};